import React, { Component, Fragment } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { Form } from 'informed'

import StatisticsWrapper from './StatisticsWrapper'
import { DataTable } from 'components//DataTable'
import { AnimatedRowGroup, CellFooter } from 'components//DataTable/components'
import { Select, Checkbox, DateTimePicker, FieldList } from 'components/forms'
import { DateIntervalFormModal } from 'components/shared/DateIntervalForm'
import Button from 'components/Button'
import Card from 'components/Card'
import { ViewList } from './modals'
import Divider from 'components/Divider'
import sumArrVals from 'helpers/sumArrVals'
import itemInArrObjsByValue from 'helpers/itemInArrObjsByValue'

import { dataProductList, randomIntegerInRange } from './tempData/'

const data = len => {
		const out = [],
			days = ['08.01.2018 - Mo', '12.01.2018 - Fr', '02.01.2018 - Di', '24.01.2018 - Fr']

		for (let i = 1; i <= len; i += 1) {
			const // num = i.toString().padStart(3, '0'),
				// randomFloat = (+Math.random().toFixed(2)),
				randomDay = randomIntegerInRange(0, 3),
				randomTime = `${randomIntegerInRange(0, 23)}:00 - ${randomIntegerInRange(0, 23)}:59`,
				random1 = Math.floor(Math.random() * 10),
				random2 = Math.floor(Math.random() * 100) + (+Math.random().toFixed(2)),
				random2Int = Math.floor(Math.random() * 100)//,
				// random3 = Math.floor(Math.random() * 1000) + (+Math.random().toFixed(2)),
				// random4 = Math.floor(Math.random() * 10000) + (+Math.random().toFixed(2))

			out.push({
				day: days[randomDay],
				time: randomTime,
				sales: random2,
				customers: random1,
				salesPerCustomer: random2,
				customerCredit: random2Int,
				customerKK: 1.00,
				KKPercustomerKK: random2Int
			})
		}
		return out
	},
	tableData = data(15),
	columns = [
		// Column to group
		{ Tag: 'Day', accessor: 'day', className: 'td-merged -hidden', Aggregated: () => (<span />), show: false },
		{
			Header: 'Zeit',
			accessor: 'time',
			Footer: (<span>Insgesamt:</span>),
			Aggregated: ({ row }) => <span>Filiale: {row.day}</span>,
			className: 'td-expander'
		},
		{
			Header: 'Umsatz',
			accessor: 'sales',
			aggregate: vals => sumArrVals(vals),
			Footer: allData => <CellFooter allData={tableData} colName='sales' />
		},
		{
			Header: 'Kunden',
			accessor: 'customers',
			aggregate: vals => sumArrVals(vals),
			Footer: allData => <CellFooter allData={tableData} colName='customers' />
		},
		{
			Header: 'Umsatz/Kunde',
			accessor: 'salesPerCustomer',
			Cell: ({ row: { sales, customers } }) => {
				return(<span>{isNaN(sales / customers) ? '-' : (sales / customers).toFixed(2)}</span>)
			},
			aggregate: vals => sumArrVals(vals),
			Footer: allData => <CellFooter allData={tableData} colName='salesPerCustomer' />
		},
		{
			Header: 'Kredit Kunde',
			accessor: 'customerCredit',
			aggregate: vals => sumArrVals(vals),
			Footer: allData => <CellFooter allData={tableData} colName='customerCredit' />
		},
		{
			Header: 'Kunden KK',
			accessor: 'customerKK',
			aggregate: vals => sumArrVals(vals),
			Footer: allData => <CellFooter allData={tableData} colName='customerKK' />
		},
		{
			Header: 'KK/Kunden KK ',
			accessor: 'KKPercustomerKK',
			aggregate: vals => sumArrVals(vals),
			Footer: allData => <CellFooter allData={tableData} colName='KKPercustomerKK' />
		}
	]

class CustomerActivity extends Component {
	state = {
		showStatistics: false,
		values: {},
		expanded: []
	}

	handlerDataStatisticsSubmit = () => {
		this.setState({ showStatistics: true })
	}

	handleAddFieldListItem = (field, items, valFromOptions = true) => {
		const { values } = this.state,
			newValues = items.map((item, i) => {
				let formData
				if(valFromOptions) {
					formData = itemInArrObjsByValue(item, dataProductList(20), 'id')
				} else {
					const strVal = typeof item === 'object' ?
						Object.values(item).join(' - ') : item

					formData = { id: Math.floor(Math.random() * 100), value: strVal }
				}

				return formData
			})

		this.setState({
			values: {
				...values,
				[field]: valFromOptions ? newValues : [...values[field] || [], ...newValues]
			}
		})
	}

	handleDelFieldListItem = ({ field, value }) => {
		this.setState({
			values: {
				...this.state.values,
				[field]: this.state.values[field].filter(item => item.id !== value)
			}
		})
	}

	handleRowClick = (state, rowInfo) => {
		/* eslint-disable no-underscore-dangle */
		let realInd = null
		const pivotVal = rowInfo.row._pivotVal

		state.pageRows.forEach((row, i) => {
			if(row._pivotVal === pivotVal) {
				realInd = i
			}
		})
		/* eslint-enable no-underscore-dangle */
		if(realInd !== null) {
			this.setState({
				expanded: {
					...this.state.expanded,
					[realInd]: !this.state.expanded[realInd]
				}
			})
		}
	}

	getTrProps = (state, rowInfo) => {
		if(!rowInfo) {
			return {}
		}

		/* eslint-disable no-underscore-dangle */
		let realInd = null
		const pivotVal = rowInfo.row._pivotVal

		state.pageRows.forEach((row, i) => {
			if(row._pivotVal === pivotVal) {
				realInd = i
			}
		})
		/* eslint-enable no-underscore-dangle */

		return {
			className: this.state.expanded[realInd] ? 'expanded' : ''
		}
	}

	render({ values } = this.state) {
		const formStatistics = (
			<Form onChange={(formState) => {/*console.log(formState.values)*/}} render={({ formApi }) => (
				<Fragment>
					<Row>
						<Col xs={2} style={{ flexBasis: '14%' }}>
							<DateTimePicker
								field='date1'
								label='Bereich' />
							<div>
								<Checkbox field='time' label='Zeit' />
							</div>
						</Col>
						<Col xs={3}>
							<Select label='Zelt' field='zelt' />
							<div>
								<Checkbox field='kreditkunde' label='Kreditkunde' />
							</div>
						</Col>
						<Col xs={3}>
							<DateTimePicker
								field='timePeriod'
								interval={true}
								label={{ from: 'Von', to: 'Bis' }}
								picker='time'
								inRow={true} />
						</Col>
					</Row>
					<Divider visible />
					<Row className='statistics-form-card'>
						<Col xs={3}>
							<DateIntervalFormModal onSubmit={val => this.handleAddFieldListItem('periodsList', [val], false)}>
								{onOpenDate => (
									<Card id='periodsList' label='Einzelne Tage' cardAction={'add'} onAdd={onOpenDate} noDataText='Einzelne Tage abwesend'>
										{(values.periodsList && values.periodsList.length) &&
											<FieldList
												field='periodsList'
												listItems={values.periodsList.map(val => ({ id: val.id, value: val.value }))}
												onDelItem={this.handleDelFieldListItem} />
										}
									</Card>
								)}
							</DateIntervalFormModal>
						</Col>
						<Col xs={3}>
							<Card
								id='cashBoxList'
								label='Kassen'
								noDataText='Kassen abwesend'
								listContent
								modal={{
									content: <React.Fragment />,
									width: 820
								}}>
								{(values.cashBoxList && values.cashBoxList.length) &&
									<FieldList listItems={values.cashBoxList} field='cashBoxList' onDelItem={this.handleDelFieldListItem} />
								}
							</Card>
						</Col>
						<Col xs={3}>
							<Card
								id='viewList'
								label='Ansicht'
								noDataText='Ansicht abwesend'
								listContent
								modal={{
									content: <ViewList onSubmit={val => this.handleAddFieldListItem('viewList', [val], false)} />,
									width: 340
								}}>
								{(values.viewList && values.viewList.length) &&
									<FieldList listItems={values.viewList} field='viewList' onDelItem={this.handleDelFieldListItem} />
								}
							</Card>
						</Col>
					</Row>
					<Divider />
					<Button onClick={this.handlerDataStatisticsSubmit} text='Berechnen' status='primary' />
				</Fragment>
			)}/>
		)

		return(
			<StatisticsWrapper statisticsData={formStatistics} showStatistics={this.state.showStatistics} switchLabel='Erweitern Kundenfrequenzen'>
				{this.state.showStatistics &&
					<div>
						<DataTable
							data={tableData}
							columns={columns}
							withSearch
							style={{ height: '408px' }}
							className='table-parent'
							getTrProps={this.getTrProps}
							onRowClick={this.handleRowClick}
							expanded={this.state.expanded}
							pivotBy={['day']}
							TrGroupComponent={AnimatedRowGroup}
						/>
						<Divider />
						<div>
							<Button text='export in excel' status='transparent' />
							<Button text='Vorschau' status='primary' />
							<Button text='grafisch' status='primary' />
						</div>
					</div>
				}
			</StatisticsWrapper>
		)
	}
}

export default CustomerActivity
